import React , {Component} from 'react';
import {
    Page  , Link , Actions , ActionsGroup , ActionsLabel , ActionsButton
} from 'framework7-react';
import randomstring  from 'randomstring';

import * as axios from "axios/index";
import validator from 'validator';
import Loading from "../Loader/Loading";

import Select from 'react-select';
import { connect } from "react-redux";
import {
    toolbar
} from "../actions";
import * as vars from './Vars';

class SingUp extends Component{


    onPageBeforeIn(){
        this.props.toolbar(false)
    }


    componentDidMount(){
        if (localStorage.getItem('logged') !== undefined && localStorage.getItem('logged') !== null )
        {
            this.$f7router.navigate('/')
            return false
        }



        let data = new FormData()
        axios.post(vars.PreUrl + 'https://www.lavefood.com/v3/delivery/list' , data )
            .then(response => {

                let data = response.data.result[0]
                if(data.error === 0)
                {
                    this.setState({
                        deliveryList:  data.delivery_list ,
                        requestLoading : false
                    })

                    console.log( data.delivery_list)
                }
                else
                {
                    this.setState({
                        requestLoading : false ,
                        modal : {
                            modalMessageShow : true ,
                            modalMessageBody :  "مشکلی پیش آمده. لطفا مجددا تلاش کنید",
                            modalMessageTitle : "خطا" ,


                        }
                    })
                }




            })
            .catch(error => {
                console.log(error)
                this.setState({
                    requestLoading : false ,
                    modal : {
                        modalMessageShow : true ,
                        modalMessageBody :  "مشکلی پیش آمده. لطفا مجددا تلاش کنید",
                        modalMessageTitle : "خطا" ,


                    }
                })
            })

    }

    constructor(props){
        super(props)
        this.state = {
            fields : {
                mobile : "09" ,
                telephone : "0" ,
                name : '' ,
                address : '' ,
                city : 'بابل' ,
                deliveryId : ""
            } ,
            errors : {} ,
            modal : {
                modalMessageShow : false ,
                modalMessageBody : "" ,
                modalMessageTitle : "" ,
            } ,
            requestLoading : true ,

            signUpLevel : 0 ,
            deliveryList : [] ,

            deliveryListShow : [] ,

        }
    }





    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
        console.log(target.value)
    }

    handleSubmit(event){
        event.preventDefault()

        this.handleValidation( (valid) => {
            if (valid)
            {

                this.setState({
                    requestLoading : true
                })
                let imeiCode = "web-app-" + randomstring.generate(10)
                localStorage.setItem('imeiCode' , imeiCode)
                let data = new FormData()
                data.append('mobile' , this.state.fields.mobile )
                data.append('imei_code' , imeiCode )


                data.append('user_app_version' , '100' )
                data.append('a_token' , 'webapp' )
                data.append('name' , this.state.fields.name )
                data.append('telephone' , this.state.fields.telephone )
                data.append('address' , this.state.fields.address )
                data.append('delivery_ID' , this.state.fields.deliveryId )


                axios.post(vars.PreUrl + 'https://www.lavefood.com/v1/register' ,
                    data )
                    .then(response => {
                        console.log(response)
                        let data = response.data.result[0]
                        if(data.error === 0)
                        {
                            this.setState({
                                requestLoading : false
                            })
                            localStorage.setItem('mobile' , this.state.fields.mobile)
                            this.$f7router.navigate('/mobile-authentication/')
                        }
                        else
                        {
                            console.log(1)
                            this.setState({
                                requestLoading : false ,
                                modal : {
                                    modalMessageShow : true ,
                                    modalMessageBody :  data.error_body ,
                                    modalMessageTitle : "خطا" ,


                                }
                            })

                        }
                    })
                    .catch(error => {
                        console.log(2)
                        console.log(error)
                        this.setState({
                            requestLoading : false ,
                            modal : {
                                modalMessageShow : true ,
                                modalMessageBody :  "مشکلی پیش آمده. لطفا مجددا تلاش کنید",
                                modalMessageTitle : "خطا" ,


                            }
                        })
                    })
            }
            else {
                let errors = this.state.errors
                let errorsString = ""
                let signUpLevel = 0
                Object.keys(errors).map(function(objectKey, index) {
                    errorsString += errors[objectKey]
                    if (objectKey === "mobile")
                        signUpLevel = 1
                })

                this.setState({
                    signUpLevel : signUpLevel ,
                    modal : {
                        modalMessageShow : true ,
                        modalMessageBody : errorsString ,
                        modalMessageTitle :  "خطا",
                    } ,
                })
            }

        })
    }

    handleModalClose(){
        this.setState({
            modal : {
                modalMessageShow : false ,
            }
        })
    }



    handleValidation(callback){
        let { fields } = this.state
        let errors = {}
        let formIsValid = true
        if (validator.isEmpty(fields.mobile))
        {
            formIsValid = false;
            errors['mobile'] = 'شماره موبایل خود را وارد کنید';
        }
        else if(! validator.isLength(fields.mobile , { min : 11 , max : 11}))
        {
            formIsValid = false;
            errors['mobile'] = 'موبایل خود را صحیح وارد کنید';
        }
        else if(! validator.isMobilePhone(fields.mobile) )
        {
            formIsValid = false;
            errors['mobile'] = 'موبایل خود را صحیح وارد کنید';
        }

        this.setState({errors} , () => {
            return callback(formIsValid)
        })
    }


    handleLevel(event){
        event.preventDefault()
        this.setState({
            signUpLevel : this.state.signUpLevel + 1
        })
    }


    handleLevelBack(event){
        event.preventDefault()
        this.setState({
            signUpLevel : this.state.signUpLevel - 1
        })
        if (this.state.signUpLevel < 0)
            this.setState({
                signUpLevel : 0
            })
    }


    render(){
        const {errors} = this.state
        const deliveryList = [];
        const city = this.state.fields.city
        this.state.deliveryList.forEach(function (delivery) {
            if( delivery.location.startsWith(city) )
            {
                deliveryList.push({
                    label : delivery.location ,
                    value : parseInt( delivery.ID)
                })
            }
        })

        return(
            <Page name="SingUp"  className="bg-white" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>
                <Loading show={this.state.requestLoading} />
                <div id="inner-header" >

                    <Link back id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        ثبت نام
                    </div>
                </div>






                <div  className="input-container">



                    <div  className={this.state.signUpLevel === 0 ? 'd-block' : 'd-none'}>

                        <form onSubmit={this.handleLevel.bind(this)}>

                            <label htmlFor="phone" className="label">
                                <img src="https://www.lavefood.com/webappassets/images/profile.svg" className="img"/>
                                <div className="title">
                                    نام و نام خانوادگی
                                </div>
                                <h5 className="description">
                                    نام و نام خانوادگی کامل خود را وارد کنید
                                </h5>
                            </label>
                            <div className="form-group">
                                <input
                                    type="text"
                                    className={["form-control direction-rtl input-field font-fa" , errors['name'] ? 'is-invalid' : ''].join(' ')}
                                    name="name"
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.fields.name}  />
                                <span className={["invalid-feedback" ,  errors['name'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['name'] }</span>
                            </div>
                            <div className="form-group">
                                <button className="btn btn-custom-4">
                                    ادامه
                                    <i className="fas fa-angle-left b-icon" />
                                </button>
                            </div>


                        </form>

                    </div>



                    <div  className={this.state.signUpLevel === 1 ? 'bg-color-white d-block' : 'bg-color-white d-none'}>

                        <form onSubmit={this.handleLevel.bind(this)}>
                            <label htmlFor="phone" className="label">
                                <img src="https://www.lavefood.com/webappassets/images/smartphone-line.svg" className="img"/>
                                <div className="title">
                                    شماره همراه
                                </div>
                                <h5 className="description">
                                    شماره تلفن همراه خود را وارد کنید، تا کد فعال سازی آن برایتان ارسال شود
                                </h5>
                            </label>
                            <div className="form-group">
                                <input
                                    type="number"
                                    className={["form-control direction-ltr input-field font-en" , errors['mobile'] ? 'is-invalid' : ''].join(' ')}
                                    name="mobile"
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.fields.mobile}  />
                                <span className={["invalid-feedback" ,  errors['mobile'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['mobile'] }</span>
                            </div>
                            <div className="form-group">
                                <div className="b-row">
                                    <div className="b-col-3">
                                        <div className="btn btn-custom-5" onClick={this.handleLevelBack.bind(this)}>
                                            <i className="fas fa-angle-right b-icon" />
                                        </div>
                                    </div>
                                    <div className="b-col-9">
                                        <button className="btn btn-custom-4">
                                            ادامه
                                            <i className="fas fa-angle-left b-icon" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>



                    <div  className={this.state.signUpLevel === 2 ? 'bg-color-white d-block' : 'bg-color-white d-none'}>

                        <form onSubmit={this.handleLevel.bind(this)}>
                            <label htmlFor="phone" className="label">
                                <img src="https://www.lavefood.com/webappassets/images/phone-line.svg" className="img"/>
                                <div className="title">
                                    تلفن ثابت
                                </div>
                            </label>
                            <div className="form-group">
                                <input
                                    type="number"
                                    className={["form-control direction-ltr input-field font-en" , errors['telephone'] ? 'is-invalid' : ''].join(' ')}
                                    name="telephone"
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.fields.telephone}  />
                                <span className={["invalid-feedback" ,  errors['telephone'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['telephone'] }</span>
                            </div>

                            <div className="form-group">
                                <div className="b-row">
                                    <div className="b-col-3">
                                        <div className="btn btn-custom-5" onClick={this.handleLevelBack.bind(this)}>
                                            <i className="fas fa-angle-right b-icon" />
                                        </div>
                                    </div>
                                    <div className="b-col-9">
                                        <button className="btn btn-custom-4">
                                            ادامه
                                            <i className="fas fa-angle-left b-icon" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>



                    <div  className={this.state.signUpLevel === 3 ? 'bg-color-white d-block' : 'bg-color-white d-none'}>

                        <form onSubmit={this.handleSubmit.bind(this)}>
                            <label htmlFor="phone" className="label">
                                <img src="https://www.lavefood.com/webappassets/images/city.svg" className="img"/>
                                <div className="title">
                                    انتخاب شهر
                                </div>
                            </label>

                            <div className="form-group">
                                <select name="city" className="form-control input-field-2" defaultValue={this.state.fields.city} onChange={this.handleChange.bind(this)}>
                                    <option value="بابل">بابل</option>
                                    <option value="ساری">ساری</option>
                                    <option value="قائمشهر">قائمشهر</option>
                                    <option value="بابلسر">بابلسر</option>
                                    <option value="آمل">آمل</option>
                                </select>
                            </div>



                            <label htmlFor="delivery_ID" className="label">
                                <img src="https://www.lavefood.com/webappassets/images/location-2.svg" className="img"/>
                                <div className="title">
                                    انتخاب محدوده
                                </div>
                            </label>

                            <div className="form-group">
                                <Select options={deliveryList} name="delivery_ID" onChange={opt => this.setState({fields : { ...this.state.fields , deliveryId : opt.value }})} />
                            </div>




                            <label htmlFor="address" className="label">
                                <img src="https://www.lavefood.com/webappassets/images/map2.svg" className="img"/>
                                <div className="title">
                                    آدرس کامل
                                </div>
                            </label>


                            <div className="form-group">
                                <textarea name="address" onChange={this.handleChange.bind(this)}  className="form-control input-field" />
                                <span className={["invalid-feedback" ,  errors['address'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['address'] }</span>
                            </div>



                            <div className="form-group">
                                <div className="b-row">
                                    <div className="b-col-3">
                                        <div className="btn btn-custom-5" onClick={this.handleLevelBack.bind(this)}>
                                            <i className="fas fa-angle-right b-icon" />
                                        </div>
                                    </div>
                                    <div className="b-col-9">
                                        <button className="btn btn-custom-4">
                                            ثبت نام
                                            <i className="fas fa-angle-left b-icon" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>


                </div>










                <Actions className="modal-custom-1"  ref="actionsOneGroup" opened={this.state.modal.modalMessageShow}  onActionsClosed={() => this.handleModalClose(false)}>
                    <ActionsGroup>
                        <ActionsLabel>{this.state.modal.modalMessageTitle}</ActionsLabel>
                        <div className="content">
                            {this.state.modal.modalMessageBody}
                        </div>
                        <div className="footer">
                            <ActionsButton>
                                <span className="footer-close">
                                    خب
                                </span>
                            </ActionsButton>
                        </div>
                    </ActionsGroup>
                </Actions>
            </Page>

        )
    }
}

const mapDispatchToProps = dispatch => ({

    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps  , mapDispatchToProps)(SingUp);
